/* eslint no-underscore-dangle: 0 */
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import FontColorPlugin from 'src/components/widgets/Editor/fontColorPlugin';
import {
  Box,
  Link,
  Button,
  Card,
  Chip,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  // FormControl,
  // FormControlLabel,
  Grid,
  List,
  ListItem,
  // MenuItem,
  // Select,
  makeStyles,
  // Switch,
  Tab,
  Tabs,
  Theme,
  // Tooltip,
  Typography,
  useTheme,
  CircularProgress,
  Tooltip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Avatar,
} from '@material-ui/core';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CancelIcon from '@material-ui/icons/Cancel';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
// import TranslateIcon from '@material-ui/icons/Translate';
import parseHTML from 'html-react-parser';
import moment from 'moment';
import { Fragment, /* useCallback, */ useEffect, useRef, useState } from 'react'; import 'react-datepicker/dist/react-datepicker.css';
import toast from 'react-hot-toast';
import { useParams, useNavigate } from 'react-router-dom';
import { casesApi } from 'src/api/casesApi';
import { translationApi } from 'src/api/translateApi';
import { userApi } from 'src/api/userApi';
import SimpleBreadCrumb from 'src/components/widgets/BreadCrumb/SimpleBreadCrumb';
import CustomButton from 'src/components/widgets/buttons/CustomButton';
import { UserActivity } from 'src/components/widgets/display-blocks/user-activity';
// import FileUploadDragDrop from 'src/components/widgets/fileUpload/FileUploadDragDrop';
import DocumentViewer from 'src/components/widgets/modal/DocumentViewer';
import { ImagePreviewer } from 'src/components/widgets/modal/ImagePreviewer';
import useAuth from 'src/hooks/useAuth';
import setTitle from 'src/utils/setTitle';
import time from 'src/utils/time';
import { formatDate } from 'src/utils/formatDate';
import ApproveDialog from './ApproveDialog';
import DeclineDialog from './DeclineDialog';
import logger from 'src/utils/logger';
import convertSecondsToTimeString from 'src/utils/convertSecondsToTimeString';
import ApproveProductionDialog from './ApproveProductionDialog';
import RejectProductionDialog from './RejectProductionDialog';
import useHasPermissions from 'src/hooks/useHasPermission';
import { CLIENT_CASES_UPDATE } from 'src/constants/constants';
// import { useSelector } from 'react-redux';

const smallShadow = '0px 0px 8px 0px rgba(0, 0, 0, 0.08);';

export const editCaseStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    '.MuiPaper-root-MuiCard-root': {
      boxShadow: smallShadow,
    },
    '& .caseLink': {
      '& .caseName': {
        color: '#000',
      },
    },
    select: {
      backgroundColor: '#FFECEC',
      color: '#E53E3E',
      fontWeight: '700',
      '& .MuiSelect-select': {
        padding: '8px 16px',
      },
      '&.Mui-disabled': {
        backgroundColor: '#FFECEC',
        color: '#E53E3E',
      },
    },
    leftSideBarRoot: {
      padding: '10px 10px',
    },
    label: {
      letterSpacing: ' 0.15px',
      color: '#231F20',
      fontWeight: '600',
      paddingBottom: '6px',
      display: 'block',
      fontSize: '14px',
    },
    meta: {
      width: '100%',
      gap: 8,
      fontSize: '14px',
      marginBottom: 8,
      fontWeight: 500,
      color: theme.palette.grey[500],
      '& .author': {
        fontWeight: 600,
        color: theme.palette.grey[600],
      },
    },
    customRadio: {
      '&.Mui-checked': {
        color: theme.palette.primary.main,
      },
    },

    box: {
      '& .MuiAutocomplete-root': {
        '& .Mui-disabled': {
          cursor: 'not-allowed',
        },
      },
      '& .orgEditCase': {
        padding: 0,
        '& .MuiAccordion-root': {
          '& .MuiAccordionDetails-root': {},
        },

        '& .MuiAccordionDetails-root': {
          padding: '16px',
          background: '#fff!important',
          borderRadius: '0 0 4px 4px',
        },
        '& .MuiAccordionSummary-root': {
          background: '#fff !important',
          color: '#231F20 !important',
          borderRadius: '4px 4px 0 0',
          padding: '0 16px',
          flexDirection: 'initial',
        },
      },
      '& .MuiAccordionSummary-expandIconWrapper ': {
        color: '#000 !important',
      },
      '& .boxSub': {
        background: '#fff',
        padding: '20px',
        boxShadow: smallShadow,
        borderRadius: '10px',
        '& .caseTitleDescription': {
          color: '#888888',
          fontSize: '14px',
          fontWeight: 600,
          margin: 0
        },
        '& label': {
          color: '#888888',
          fontSize: '12px',
          fontWeight: 600,
        },
        '& .boxHeader': {
          background: '#fff',
          color: '#231F20',
          padding: '7px 24px',
          borderRadius: '4px 4px  0  0',
          height: '39px',
        },

        '& p': {
          margin: '10px 0 10px',
        },
        '& .editorMarkup': {
          '& .wmde-markdown-var': {
            border: '1px solid transparent',
          },
        },
        '& .editorMarkupError': {
          '& .wmde-markdown-var': {
            border: `1px solid ${theme.palette.primary.main}`,
          },
        },
        '& .btnComments': {
          display: 'flex',
          justifyContent: 'flex-end',
          '& button+button': {
            marginLeft: '12px',
          },
        },
        '& .MuiFormHelperText-root': {
          margin: 0,
        },
      },
      '& .commentBoxRoot': {
        marginTop: '25px',
      },
      '& .commentBox': {
        marginTop: '10px',
        padding: '10px 25px',
        border: '1px solid #eceaea',
        borderRadius: '5px',
        '& .commentBoxInner': {
          display: 'flex',
          alignItems: 'start',

          '& h4': {
            fontSize: '14px',
            fontWeight: 'bold',
            margin: 0,
          },
          '& span': {
            fontSize: '14px',
            marginLeft: '10px',
          },
        },
        '& p': {
          margin: '0px 0px 0px 0px !important',
        },
        '& span': {
          fontSize: '14px',
        },
        '& span+span': {
          marginLeft: '10px',
        },
      },
      '& .commentBox.current': {
        border: '1px solid #231f20',
      },
      '& select, & .MuiAutocomplete-inputRoot, & input': {
        height: '38px',
        padding: '0 10px',
        lineHeight: '116.7%',
        color: '#696969',
        width: '100%',
        '& .MuiAutocomplete-input': {
          padding: 0,
        },
      },
      '& .customField': {
        height: '38px',
        padding: '0 10px',
        lineHeight: '116.7%',
        color: '#696969',
        width: '100%',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        '& .MuiChip-root': {
          border: 0,
          borderRadius: '4px',
          margin: '2px 0',
          background: 'rgb(241 240 240)',
        },
      },
      '& .labelsDataCss .MuiAutocomplete-inputRoot': {
        height: 'initial',
      },

      '& .labelField': {
        // width: '50%',
      },
      '& .caseRightInner+.caseRightInner': {
        marginTop: '8px',
      },
      '& .sLa': {
        display: 'flex',
        fontSize: '14px',
        alignItems: 'center',
        '& .btnTime': {
          width: '179px',
          height: '36px',
          borderRadius: '43px',
          background: '#B0B0B0',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& svg': {
            marginLeft: '10px',
          },
        },
        '& .btnTime.bgRed': {
          background: '#CC4D53',
        },
        '& .btnTimeFirst': {
          width: '179px',
          height: '36px',
          borderRadius: '43px',
          background: '#B0B0B0',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& svg': {
            marginLeft: '10px',
          },
        },
        '& .btnTimeFirst.bgRed': {
          background: '#CC4D53',
        },
        '& .resolveTime': {
          fontSize: '14px',
          fontWeight: 'bold',
          marginLeft: '10px',
          '& p': {
            fontSize: '12px',
            fontWeight: 'normal',
            margin: '2px 0 0',
          },
          '& svg': {
            marginLeft: '10px',
          },
        },
      },
      '& .jiraSync': {
        marginTop: '0px',
        '& b': {
          fontSize: '14px',
        },
        fontSize: '12px',
      },
      '& .escalations': {
        display: 'flex',
        '& span': {
          fontSize: '14px',
        },
      },
      '& .rightSide': {
        boxShadow: smallShadow,
        '& hr': {
          border: 0,
          borderTop: '0.8px solid #f2f4f7',
          margin: '12px 0',
          borderWidth: '0.8px',
        },
      },
      '& .rightAccordion': {
        '& .MuiTypography-h4': {
          color: '#231f20',
          fontSize: '1rem',
          fontWeight: 600,
        },
        '& label': {
          color: '#231f20',
          fontSize: '12px',
          fontWeight: 600,
        },
      },
      '& .createdAt': {
        fontSize: '14px',
        color: '#777',
        '& p': {
          margin: '0',
        },
        '& span': {
          fontWeight: 500,
        },
      },
      '& .btnCommentInner': {
        marginTop: 2,
        display: 'flex',
        position: 'absolute',
        top: 10,
        right: 10,
        gap: '8px',
        '& button': {
          display: 'flex',
          cursor: 'pointer',
          border: '1px solid transparent',
          borderRadius: '3px',
          color: '#696969',
          backgroundColor: 'rgba(0 0 0/0)',
          transition: 'all 300ms',
          '&:hover': {
            backgroundColor: 'rgba(0 0 0/0.1)',
          },
        },
      },
      '& .MuiLink-root': {
        '&:hover': {
          textDecoration: 'none !important',
        },
      },
      '& .attachmentsDiv': {
        marginTop: '30px',
        '& .editCommentFileParent': {
          display: 'flex',
          justifyContent: 'flex-start',
          flexWrap: 'wrap',
          gap: '10px',
          '& a': {
            position: 'relative',
            display: 'inline-flex',
            borderRadius: 6,
            marginBottom: 8,
            width: 80,
            height: 80,
            padding: 8,
            color: ' #757575',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            border: `1px solid ${theme.palette.grey[300]}`,
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            '&:hover': {
              borderColor: theme.palette.primary.main,
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              transform: 'translateY(-2px)',
            },
            '&  .editCommentFileEdit': {
              position: 'absolute',
              top: '-10px',
              right: '-10px',
              cursor: 'pointer',
              color: theme.palette.primary.main,
            },
            '&  span': {
              position: 'absolute',
              background: ' #f7f7f7',
              fontSize: '8px',
              bottom: '10px',
              left: '50%',
              transform: 'translateX(-50%)',
              padding: '2px 4px',
              fontWeight: 'bold',
              borderRadius: '3px',
              whiteSpace: 'nowrap',
              // zIndex: 1,
            },
          },
        },
        '& a img': {
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        },
        '& img': {
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          borderRadius: '4px',
        },
      },
    },
    commentHelperText: {
      margin: '0px',
    },
    commentsTabRoot: {
      marginTop: '15px',
      borderRadius: '4px 4px 0 0',
      '& .MuiTabs-flexContainer': {
        backgroundColor: '#ddd',
        height: '39px',
        border: 'none',
      },
      '& .Mui-selected': {
        '& .MuiTab-wrapper': {
          color: '#333',
        },
      },
      '& .MuiButtonBase-root.Mui-selected[aria-selected="true"]': {
        fontWeight: '700',
        backgroundColor: 'transparent !important',
        border: 'none !important',
      },
      '& .MuiButtonBase-root': {
        textTransform: 'capitalize',
        color: '#333',
        fontWeight: 400,
        fontSize: '1rem',
        minHeight: '39px!important',
        minWidth: '155px !important',
      },
      '& .MuiButtonBase-root:first-child': {
        marginLeft: 0,
      },
      '& .MuiTabs-indicator': {
        backgroundColor: `${theme.palette.primary.main} !important`,
        height: '4px!important',
        top: '39px!important',
        display: 'block!important',
      },
    },
    commentsPreview: {
      // marginLeft: '50px',
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      minWidth: 0,
      marginTop: 16,
      '& .comment-thread': {
        marginBottom: '2rem',
      },
      '& .commentHtml': {
        '& figure': {
          margin: '4px 0',
        },
        '& figure.image': {
          display: 'table',
          margin: '4px 0',
        },
        '& figure.image img, & img': {
          maxWidth: 120,
          width: 'auto',
          height: 'auto',
          borderRadius: 4,
          cursor: 'pointer',
        },
        '& figure.table, & .table': {
          display: 'block',
          width: '100%',
          overflowX: 'auto',
        },
        '& table': {
          borderCollapse: 'collapse',
          width: 'max-content',
          minWidth: '100%',
          tableLayout: 'auto',
        },
        '& th, & td': {
          wordBreak: 'normal',
          overflowWrap: 'normal',
          whiteSpace: 'nowrap',
          minWidth: '2em',
          padding: '6px 10px',
          border: '1px solid #d1d5db',
          verticalAlign: 'top',
        },
      },
      '& .MuiListItemText-root': {
        margin: 0,
        fontSize: '14px',
        fontWeight: 300,
        '& strong': {
          color: '#000',
        },
      },
    },
    timelineRoot: {
      margin: 0,
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      '& p': {
        margin: '0px!important',
        wordBreak: 'break-all',
      },
      '& .MuiAvatar-root': {
        backgroundColor: '#231f20',
        width: '40px',
        height: '40px',
      },
      '& img': {
        width: ' 60px',
        height: '67px',
        objectFit: 'contain',
      },
      '& .MuiListItemText-root': {
        margin: 0,
        fontSize: '14px',
        fontWeight: 300,
        '& strong': {
          color: '#000',
        },
      },
    },

    detailsRoot: {
      display: 'grid',
      gridTemplateColumns: '49% 49%',
      rowGap: '5px',
      columnGap: '10px',
      '& .MuiAutocomplete-root .MuiChip-root': {
        maxWidth: '115px',
      },
      '& .MuiAutocomplete-root .MuiAutocomplete-tag': {
        fontSize: '12px',
      },
      [theme.breakpoints.down(1850)]: {
        gridTemplateColumns: '1fr',
      },
    },
    transalationBtn: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      cursor: 'pointer',
    },
    externalComment: {
      backgroundColor: `${theme.palette.primary.main}11`,
      // boxShadow: '0px 0px 1px 1px #ffb0b0',
    },
    commentEditorContainer: {
      border: '2px solid white',
      borderRadius: 4,
      '& .ck-editor__editable': {
        minHeight: '40px',
        fontSize: '12px',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap',
      },
      '& .ck-content': {
        fontSize: '12px',
      },
      '& .ck-content p': {
        fontSize: '12px',
      },
      '& .ck-content figure.image': {
        display: 'table',
        margin: '8px 0',
      },
      '& .ck-content figure.image img, & .ck-content img': {
        maxWidth: 240,
        width: 'auto',
        height: 'auto',
      },
      '& .ck-font-color': {
        position: 'relative',
      },
      '& .ck-font-color-button': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 28,
        height: 28,
        padding: '2px 4px',
        cursor: 'pointer',
      },
      '& .ck-font-color-letter': {
        fontSize: 14,
        fontWeight: 700,
        lineHeight: 1,
        color: '#333',
      },
      '& .ck-font-color-bar': {
        display: 'block',
        width: 14,
        height: 3,
        marginTop: 2,
        backgroundColor: '#000',
        borderRadius: 1,
      },
      '& .ck-font-color-panel': {
        position: 'absolute',
        top: '100%',
        left: 0,
        zIndex: 20,
        minWidth: 180,
        padding: 8,
        background: '#fff',
        border: '1px solid #c4c4c4',
        borderRadius: 4,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      },
      '& .ck-font-color-panel[hidden]': {
        display: 'none',
      },
      '& .ck-font-color-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 20px)',
        gap: 6,
      },
      '& .ck-font-color-swatch': {
        width: 20,
        height: 20,
        padding: 0,
        border: '1px solid transparent',
        borderRadius: 2,
        cursor: 'pointer',
      },
      '& .ck-font-color-remove': {
        display: 'block',
        width: '100%',
        marginTop: 8,
        padding: '4px 0',
        border: 'none',
        background: 'transparent',
        fontSize: 12,
        color: '#333',
        cursor: 'pointer',
        textAlign: 'left',
      },
      '& .editCommentFileParent': {
        display: 'flex',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        gap: '15px',
        '& a': {
          position: 'relative',
          display: 'block',
          color: ' #757575',
          cursor: 'pointer',
          border: `1px solid ${theme.palette.grey[300]}`,
          '&  .editCommentFileEdit': {
            position: 'absolute',
            top: '-10px',
            right: '-10px',
            cursor: 'pointer',
            color: theme.palette.primary.main,
          },
          '&  span': {
            position: 'absolute',
            background: ' #f7f7f7',
            fontSize: '10px',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%)',
            padding: '2px',
            fontWeight: 'bold',
          },
          '& img': {
            width: ' 60px',
            height: '67px',
            objectFit: 'contain',
          },
        },
      },
    },
    commentOptionButtons: {
      display: 'flex',
      padding: '10px',
      gap: '10px',
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: 4,
      '& .internalCommentLink': {
        cursor: 'pointer',
        paddingBottom: '5px',
        textDecoration: 'underline',
        textUnderlineOffset: '3px',
        // transition: '0.3s linear',
        '&:hover': {
          textDecoration: 'underline #f5f5f5',
          // color: '#f5f5f5'
        },
      },
      '& .externalCommentLink': {
        cursor: 'pointer',
        paddingBottom: '5px',
        textDecoration: 'underline',
        textUnderlineOffset: '3px',
        '&:hover': {
          textDecoration: 'underline #f5f5f5',
          // color: '#f5f5f5'
        },
      },
    },
    customClassAddComment: {
      padding: '5px 5px',
      width: 160,
      marginTop: '8px'
    },
    customClassUpdateComment: {
      padding: '5px 5px',
      width: 160,
      marginTop: '8px'
    },
    approveCaseButton: {
      padding: '0px 5px',
      margin: '0px 15px',
      // width: 160,
    },
    declineCaseButton: {
      padding: '0px 5px',
      marginRight: '15px',
      // width: 160,
    },
    declineButtonRed: {
      backgroundColor: 'red',
      color: 'white',
      border: `2px solid red`,
      '&:hover': {
        color: 'white',
        backgroundColor: 'darkred',
        border: `2px solid darkred`,
      },
    },
    detailsCard: {
      '&>*:nth-child(odd)': {
        color: '#7a7a9d'
      }
    }
  })
);

const useStyles = editCaseStyles;

type TimelineTypes = {
  id: string;
  description: string;
  createdBy: {
    id: string;
    name: string;
  };
  createdAt: string;
  changeFrom?: string | null;
  changeTo?: string | null;
  change: string | null;
  isExternal?: boolean;
  attachmentPath?: string;
};

type TimelineSectionTypes = {
  user: any;
  data: TimelineTypes[];
  caseData: any;
  toggleIsLoad: () => void;
  languageType?: string;
  showTranslation?: any;
  handleDocumentClick?: any;
  handleImageClick?: any;
};

const COMMENT_COLLAPSED_HEIGHT = 150;

const CaseCommentHtml = ({
  html,
  onImageClick,
}: {
  html: string;
  onImageClick: (src: string) => void;
}) => {
  const theme = useTheme();
  const contentRef = useRef<HTMLDivElement>(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showExpandButton, setShowExpandButton] = useState(false);

  useEffect(() => {
    if (contentRef.current) {
      setShowExpandButton(contentRef.current.scrollHeight > COMMENT_COLLAPSED_HEIGHT);
    }
  }, [html]);

  return (
    <>
      <Box
        ref={contentRef}
        className="commentHtml"
        onClick={(event) => {
          if (event.target instanceof HTMLImageElement && event.target.src) {
            onImageClick(event.target.src);
          }
        }}
        dangerouslySetInnerHTML={{ __html: html }}
        sx={{
          width: '100%',
          minWidth: 0,
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          padding: '2px 10px',
          backgroundColor: `${theme.palette.primary.main}11`,
          borderRadius: '8px',
          fontSize: '12px',
          color: '#4b5563',
          lineHeight: 1.5,
          maxHeight: isExpanded ? '500px' : `${COMMENT_COLLAPSED_HEIGHT}px`,
          overflow: isExpanded ? 'auto' : 'hidden',
        }}
      />
      {showExpandButton && (
        <Button
          size="small"
          type="button"
          onClick={() => setIsExpanded((prev) => !prev)}
          sx={{
            fontSize: '10px',
            padding: '2px 8px',
            minHeight: 'auto',
            float: 'right',
            mt: 0.5,
          }}>
          {isExpanded ? 'See less' : 'Click to view full comment'}
        </Button>
      )}
    </>
  );
};

export const Comments = ({
  toggleIsLoad,
  caseData,
  user,
  // languageType,
  // showTranslation,
  handleDocumentClick,
  handleImageClick,
}: any) => {
  const classes = useStyles();
  const commentRef = useRef(null);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [commentValue, setCommentValue] = useState<string>('');
  const [commentEdit, setCommentEdit] = useState<any>({});
  const [filePath, setFilePath] = useState<string[]>([]);
  const isExternalComment = true;
  const [commentDeleteId, setCommentDeleteId] = useState<string>('');
  const [cooldownTime, setCooldownTime] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    if (cooldownTime <= 0) return;

    const timer = setInterval(() => {
      setCooldownTime((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // return () => clearInterval(timer);
  }, [cooldownTime]);

  const isNotEmpty = (val: string | any[]) => {
    if (Array.isArray(val)) {
      return val.length > 0;
    }
    return typeof val === 'string' && val.trim() !== '';
  };



  const handleSaveComment = async (e) => {
    e.preventDefault();

    // 🛑 Block if cooldown is active or already submitting
    if (isSubmitting || cooldownTime > 0) {
      toast.error(`Please wait ${cooldownTime} seconds before posting again`);
      return; // This is fine; all other branches also exit cleanly
    }

    try {
      if (isNotEmpty(commentValue) || isNotEmpty(filePath)) {
        setIsSubmitting(true);
        setCooldownTime(5); // start cooldown immediately

        const payload = {
          caseId: caseData?.id,
          description: commentValue,
          isExternal: isExternalComment,
          attachmentPath: filePath,
        };

        const response = await casesApi?.createComment(payload);
        if (response?.status === 201) {
          toast.success('Comment Added');
          setCommentValue('');
          setFilePath([]);
          setTimeout(() => toggleIsLoad(), 5000);
        }
      }
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const deleteComment = async (caseId: String) => {
    try {
      const response = await casesApi?.deleteComments(caseId, commentDeleteId);
      if (response?.status === 200) {
        toast.success('Comment Deleted');
        toggleIsLoad();
        setOpenDialog(false);
        toggleIsLoad();
        if (isEditing) {
          setIsEditing(false);
          setCommentValue('');
          setCommentEdit({
            commentId: '',
          });
        }
      }
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
      }
    }
  };
  const editCommentAPI = async (e) => {
    e.preventDefault();
    try {
      if (isNotEmpty(commentValue)) {
        const payload = {
          caseId: commentEdit?.caseId,
          description: commentValue,
          attachmentPath: filePath,
        };
        const response = await casesApi?.editCaseComment(
          commentEdit?.commentID,
          payload
        );
        if (response?.status === 200) {
          toast.success('Comment Updated');
          toggleIsLoad();
          setCommentValue('');
          setIsEditing(false);
        }
      }
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
      }
    }
  };
  const editComment = async (
    caseIDs: string,
    commentId: string,
    commentDes: string,
    indexMap: Number,
    filePaths: string[]
  ) => {
    setIsEditing(true);
    setFilePath(filePaths);
    setCommentValue(commentDes);
    setCommentEdit({
      caseId: caseIDs,
      commentID: commentId,
      currentIndex: indexMap,
    });
  };
  const handleEditCommentDeleteFile = (e, index) => {
    e.stopPropagation();
    const updatedFiles = [...filePath];
    updatedFiles.splice(index, 1);
    setFilePath(updatedFiles);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  // const handleCheckExternalComment = () => {
  //   setIsExternalComment(!isExternalComment);
  // };

  function uploadAdapter(loader) {
    return {
      upload: () =>
        new Promise((resolve) => {
          loader.file.then(async (file) => {
            const formData = new FormData();
            formData.append('file', file);
            const image = await userApi.uploadAttachments(formData);
            const blobUrl = image?.data?.blob_url || image?.data?.fileUrl;
            resolve({
              default: `${blobUrl}`,
            });
          });
        }),
    };
  }
  function uploadPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) =>
      uploadAdapter(loader);
  }
  // const getImage = useSelector((state: any) => state.userInfo?.userInfos);

  // const imageSrc = (Object.keys(getImage).length < 1 ? user.image : getImage) || 'https://assets.it22.nl/fortes-energy/admin/dummy_image.png';

  // Use stored image URLs as-is (same as profile / case attachments).
  // Do not inject legacy Azure SAS tokens — they break loading on current blob storage.
  const rewriteCommentHtml = (html?: string) => {
    if (typeof html !== 'string') {
      return '';
    }
    return html;
  };

  return (
    <Box padding="17px 0 24px">
      <div
        style={{ flexGrow: 1, marginBottom: 16, fontSize: '12px', }}
        data-color-mode="light"
        className="editorMarkup"
        ref={commentRef}>
        <div className={classes.commentEditorContainer}>
          <CKEditor
            editor={ClassicEditor}
            data={commentValue}
            onChange={(event, editor) => {
              const data = editor.getData();
              setCommentValue(data);
              // Create a temporary DOM element to parse the content
              // const tempDiv = document.createElement('div');
              // tempDiv.innerHTML = data;

              // // Extract all image elements
              // const imageElements = tempDiv.querySelectorAll('img');

              // // Extract image sources
              // const imageSources = Array.from(imageElements).map((image) => image?.src);
              // setFilePath((prev) => [...prev, imageSources.length > 0 ? imageSources : '']);
              // setCommentValue(data);
            }}
            config={{
              placeholder: 'Enter your comment here',
              toolbar: [
                'heading',
                '|',
                'bold',
                'italic',
                '|',
                'link',
                'uploadimage',
                '|',
                'bulletedList',
                'numberedList',
                '|',
                'fontColor',
              ],
              extraPlugins: [uploadPlugin, FontColorPlugin],
            }}
          />
          {/* <FileUploadDragDrop setFilePath={setFilePath} filePath={filePath} /> */}
          {isEditing && (
            <div className="editCommentFileParent">
              {isEditing &&
                filePath?.map((item, index) => {
                  // Use stored URL as-is (same as profile / case attachments — no SAS rewrite)
                  const getFileType = (items) => {
                    if (items.includes('.pdf')) {
                      return 'PDF';
                    }
                    if (items.includes('.doc')) {
                      return 'DOC';
                    }
                    if (items.includes('.docx')) {
                      return 'DOCX';
                    }
                    if (items.includes('.txt')) {
                      return 'TXT';
                    }
                    return null;
                  };

                  const fileType = getFileType(item);
                  if (
                    item.includes('.pdf') ||
                    item.includes('.doc') ||
                    item.includes('.docx') ||
                    item.includes('.txt')
                  ) {
                    return (
                      <a
                        role="presentation"
                        onClick={() => handleDocumentClick(item)}>
                        {' '}
                        <span>{fileType}</span>
                        <InsertDriveFileIcon sx={{ fontSize: '60px' }} />
                        <CancelIcon
                          onClick={(e) => handleEditCommentDeleteFile(e, index)}
                          className="editCommentFileEdit"
                        />
                      </a>
                    );
                  }
                  const imageFormats = [
                    '.jpg',
                    '.jpeg',
                    '.png',
                    '.gif',
                    '.bmp',
                    '.tiff',
                    '.webp',
                    '.svg',
                    '.ico',
                  ];
                  if (
                    imageFormats.some((extension) => item?.includes(extension))
                  ) {
                    return (
                      <>
                        <a
                          role="presentation"
                          onClick={() => handleImageClick(item)}>
                          <img src={item} alt="img" />
                          <CancelIcon
                            onClick={(e) =>
                              handleEditCommentDeleteFile(e, index)
                            }
                            className="editCommentFileEdit"
                          />
                        </a>
                      </>
                    );
                  }
                  return null;
                })}
            </div>
          )}
        </div>
        <div className="btnComments">
          {!isEditing ? (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mt={1}
              width="100%"
            >
              {/* Left side: cooldown message */}
              <Box flex="1">
                {cooldownTime > 0 && (
                  <Typography
                    variant="caption"
                    color="#8492A6"
                    sx={{ display: 'block', marginLeft: '8px' }}
                  >
                    Please wait <span style={{ color: 'red' }}>{cooldownTime}</span> seconds before adding another comment.
                  </Typography>
                )}
              </Box>

              {/* Right side: Add Comment button */}
              <Box>
                <CustomButton
                  value={isExternalComment ? 'Add Comment' : 'Add Comment'}
                  customClass={classes.customClassAddComment}
                  color="secondary"
                  onClick={handleSaveComment}
                  disabled={isSubmitting || cooldownTime > 0}
                />
              </Box>
            </Box>
          ) : (
            <CustomButton
              value="Update Comment"
              color="secondary"
              customClass={classes.customClassUpdateComment}
              style={{ width: '160px !important' }}
              onClick={(e) => editCommentAPI(e)}
            />
          )}
        </div>

      </div>
      {caseData?.comment?.length !== 0 && (
        <>
          {/* <Typography
            variant="body2"
            sx={{
              fontSize: '16px',
              fontWeight: 600,
              margin: '0px 0px 8px 0px',
            }}>
            Comments
          </Typography> */}
          <Box className={classes.commentsPreview}>
            {caseData?.comment
              ?.filter((comment) => comment?.isExternal !== false)
              ?.map((comment, i) => (
                <Box
                  key={comment?.id}
                  className={`comment-thread ${isEditing && commentEdit?.currentIndex === i ? 'current' : ''}`}
                  sx={{
                    display: 'flex',
                    gap: '1rem',
                    alignItems: 'flex-start',
                    p: 1,
                    width: '100%',
                    minWidth: 0,
                  }}>
                  <Avatar
                    src={comment?.createdByAvatar || 'https://assets.it22.nl/fortes-energy/admin/dummy_image.png'}
                    sx={{
                      height: 32,
                      width: 32,
                      color: '#718096',
                      flexShrink: 0,
                    }}
                  />
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        mb: 0.5,
                        width: '100%',
                      }}>
                      <Box>
                        <Typography component="span" sx={{ fontSize: '12px', fontWeight: 500 }}>
                          {comment?.createdByName}
                        </Typography>
                        <Typography component="span" sx={{ fontSize: '12px', color: '#6b7280', ml: 0.5 }}>
                          {moment.utc(comment?.createdAt).local().format('DD MMM, YYYY - HH:mm')}
                        </Typography>
                      </Box>
                      {comment?.createdBy === user?.id && (
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Button
                            size="small"
                            title="Edit comment"
                            type="button"
                            onClick={() => {
                              editComment(
                                caseData?.id,
                                comment?.id,
                                comment?.description,
                                i,
                                comment?.attachmentPath
                              );
                            }}
                            sx={{ padding: 0, color: 'black !important', fontSize: '12px', fontWeight: '400', }}>
                            Edit
                          </Button>
                          <Button
                            size="small"
                            title="Delete comment"
                            type="button"
                            onClick={() => {
                              setOpenDialog(true);
                              setCommentDeleteId(comment?.id);
                            }}
                            sx={{ padding: 0, color: 'black !important', fontSize: '12px', fontWeight: '400' }}>
                            Delete
                          </Button>
                        </Box>
                      )}
                    </Box>
                    <CaseCommentHtml
                      html={rewriteCommentHtml(comment?.description)}
                      onImageClick={handleImageClick}
                    />
                    {Array.isArray(comment?.attachmentPath) && comment?.attachmentPath?.length > 0 && (
                      <Box sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        mt: 1,
                        '& img': {
                          width: 60,
                          height: 60,
                          objectFit: 'cover',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          border: '1px solid #e0e0e0',
                        },
                      }}>
                        {comment?.attachmentPath?.map((item) => {
                          const getFileType = (items) => {
                            if (items.includes('.pdf')) return 'PDF';
                            if (items.includes('.doc')) return 'DOC';
                            if (items.includes('.docx')) return 'DOCX';
                            if (items.includes('.xls')) return 'XLS';
                            if (items.includes('.xlsx')) return 'XLSX';
                            if (items.includes('.csv')) return 'CSV';
                            if (items.includes('.tsv')) return 'TSV';
                            if (items.includes('.txt')) return 'TXT';
                            return null;
                          };
                          const imageFormats = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff', '.webp', '.svg', '.ico'];
                          if (imageFormats.some((ext) => item?.includes(ext))) {
                            return (
                              <a role="presentation" onClick={() => handleImageClick(item)}>
                                <img src={item} alt="img" />
                              </a>
                            );
                          }
                          return (
                            <a role="presentation" onClick={() => handleDocumentClick(item)}
                              style={{
                                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                width: 64, height: 64, border: '1px solid #e0e0e0', borderRadius: 6, position: 'relative'
                              }}>
                              <span style={{ position: 'absolute', bottom: 4, fontSize: '9px', background: '#f7f7f7', borderRadius: 3, padding: '1px 3px' }}>
                                {getFileType(item)}
                              </span>
                              <InsertDriveFileIcon sx={{ fontSize: 36 }} />
                            </a>
                          );
                        })}
                      </Box>
                    )}
                  </Box>

                  <Dialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Are you sure, you want to delete a comment?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseDialog} color="primary">
                        Cancel
                      </Button>
                      <Button
                        onClick={() => deleteComment(caseData?.id)}
                        color="primary"
                        autoFocus>
                        Yes
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Box>
              ))}
          </Box>
        </>
      )}
    </Box>
  );
}; // ----> Comments()

export const TimelineSection = ({
  user,
  data,
  caseData,
  toggleIsLoad,
  languageType,
  showTranslation,
  handleDocumentClick,
  handleImageClick,
}: TimelineSectionTypes) => {
  const classes = useStyles();
  return (
    <>
      <Comments
        caseData={caseData}
        toggleIsLoad={toggleIsLoad}
        user={user}
        languageType={languageType}
        showTranslation={showTranslation}
        handleDocumentClick={handleDocumentClick}
        handleImageClick={handleImageClick}
      />
      {user?.permissions?.includes('case-timeline-activity-get-all') && (
        <List className={classes.timelineRoot}>
          {data?.length ? (
            <>
              <span
                style={{
                  fontSize: '16px',
                  fontWeight: 600,
                }}>
                Logs
              </span>
              {caseData?.logs?.map((item: TimelineTypes) => (
                <UserActivity
                  key={item?.id}
                  // image={{ src: '/static/icons/avatar.png', alt: item?.createdBy?.name }}
                  meta={{
                    description: item?.description,
                    createdBy: item?.createdBy.name,
                    createdAt: item?.createdAt,
                    change:
                      item?.change === null ? '' : parseHTML(item?.change),
                  }}
                  filesPath={item?.attachmentPath}
                  actions={[
                    <Button
                      size="small"
                      title="Translate"
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (item?.change !== null) {
                          showTranslation(
                            item?.change,
                            languageType,
                            'caseLogData',
                            item?.id
                          );
                        }
                      }}
                      sx={{ padding: '0' }}>
                      Translate
                    </Button>,
                  ]}
                  details={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                      }}>
                      {item?.changeFrom && (
                        <span style={{ fontSize: '12px' }}>
                          {item?.changeFrom === null
                            ? 'none'
                            : parseHTML(item?.changeFrom)}
                        </span>
                      )}
                      {item?.changeTo && (
                        <>
                          <span
                            style={{
                              flex: '0 0 40px',
                              textAlign: 'center',
                              margin: '-2px 0 0',
                            }}>
                            <ArrowRightAltIcon />
                          </span>
                          <span style={{ fontSize: '12px' }}>
                            {item?.changeTo === null
                              ? 'none'
                              : parseHTML(item?.changeTo)}
                          </span>
                        </>
                      )}
                    </div>
                  }
                />
              ))}
            </>
          ) : (
            <>
              <ListItem style={{ display: 'flex', justifyContent: 'center' }}>
                <strong>No Data Found</strong>
              </ListItem>
            </>
          )}
        </List>
      )}
    </>
  );
};
// ----> TimelineSection()

export const JiraSync = () => null;

interface Status {
  id: string;
  name: string;
  rank: number;
}

interface Sponsor {
  id: string;
  name: string;
}

interface Stakeholder {
  id: string;
  name: string;
}

interface Comment {
  id: string;
  description: string;
  isExternal: boolean;
  createdBy: string;
  createdByName: string;
  createdByAvatar: string;
  updatedByName: string | null;
  updatedBy: string | null;
  createdAt: string;
  updatedAt: string;
  attachmentPath: string[];
}

interface Assignee {
  id: string | null;
  name: string | null;
}

interface Organization {
  id: string;
  name: string;
}

interface Project {
  id: string;
  name: string;
}

interface IssueType {
  id: string;
  name: string;
}

interface Priority {
  id: string;
  name: string;
  rank: number;
}

interface EstimatedTime {
  firstResponseTime: string;
  resolveTime: string;
}

interface ActualTime {
  firstResponseTime: string;
  resolveTime: string;
}

interface SLA {
  estimatedTime: EstimatedTime;
  actualTime: ActualTime;
  isFirstResponseTimeViolated: boolean;
  isResolveTimeViolated: boolean;
}

interface Log {
  id: string;
  description: string;
  createdBy: {
    id: string;
    name: string;
  };
  createdAt: string;
  changeFrom: string | null;
  changeTo: string | null;
  change: string | null;
  isExternal: boolean;
}

interface Report extends Log { }

interface Severity {
  id: string;
  name: string;
  rank: number;
}

interface BugQuestion {
  questionKey: string;
  description: string;
}

interface ThirdPartySync {
  isSynced: boolean;
  syncedCaseKey: string | null;
  syncedCaseLink: string | null;
}

interface CreatedBy {
  id: string;
  name: string;
}

interface UpdatedBy {
  id: string;
  name: string;
}

interface Escalation {
  id: number;
  createdAt: string;
  escalatedBy: {
    id: string;
    name: string;
    role: string;
  };
}

interface CaseData {
  budget: any;
  generalStatus: {
    planningStatus?: string;
  };
  expectedStartDate?: string;
  expectedEndDate?: string;
  linkedCases: any;
  environment?: string;
  labels: string[];
  docUrls: any;
  id: string;
  caseKey: string;
  description: string;
  summary: string;
  status: Status;
  startDate: string;
  dueDate: string;
  projectSponsor: Sponsor[];
  stakeHolder: Stakeholder[];
  attachmentId: string[];
  comment: Comment[];
  assignee: Assignee;
  escalationManager: {
    id: string;
    name: string;
  };
  organization: Organization;
  project: Project;
  issueType: IssueType;
  caseType: {
    id: string;
    name: string;
  };
  priority: Priority;
  sla: SLA;
  logs: Log[];
  reports: Report[];
  severity: Severity;
  bugQuestions: BugQuestion[];
  thirdPartySync: ThirdPartySync;
  isEscalated: boolean;
  createdBy: CreatedBy;
  updatedBy: UpdatedBy;
  createdAt: string;
  updatedAt: string;
  escalations: Escalation[];
  sprint?: any;
  expense?: any;
  releaseVersion?: any;
  timeEstimate?: any;
  loggedTime?: any;
  isApproved?: any;
  approvedBy?: any;
  bugOccur?: any;
  bugExpect?: any;
  billingAccountType?: any;
  timeEstimateBreakDown?: any;
}
interface LogEntry {
  id: string;
  description: string;
  createdBy: {
    id: string;
    name: string;
  };
  createdAt: string;
  changeFrom?: string | null;
  changeTo?: string | null;
  change: string | null;
  isExternal?: boolean;
  attachmentPath?: string;
}
const TimeProgress = ({ estimated, remaining, logged }: { estimated: number, remaining: number, logged: number }) => {
  const percentLogged = (logged / estimated) * 100;
  const percentRemaining = (remaining / estimated) * 100;
  const theme = useTheme();

  return (
    <Box>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={4}>
          <Typography fontSize="12px">Estimated:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Box sx={{ width: '100%', height: 10, backgroundColor: '#f0f0f0', borderRadius: 5 }}>
            <Box sx={{ width: '100%', height: '100%', backgroundColor: `${theme.palette.primary.main}`, borderRadius: 5 }} />
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Typography textAlign="right" fontSize="12px">{convertSecondsToTimeString(estimated)}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography fontSize="12px">Remaining:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Box sx={{ width: '100%', height: 10, backgroundColor: '#f0f0f0', borderRadius: 5, transform: 'rotate(180deg)' }}>
            <Box sx={{ width: `${percentRemaining}%`, height: '100%', backgroundColor: `${theme.palette.primary.main}`, borderRadius: 5 }} />
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Typography textAlign="right" fontSize="12px">{convertSecondsToTimeString(remaining)}</Typography>
        </Grid>

        <Grid item xs={4}>
          <Typography fontSize="12px">Logged:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Box sx={{ width: '100%', height: 10, backgroundColor: '#f0f0f0', borderRadius: 5 }}>
            <Box sx={{ width: `${percentLogged > 100 ? 100 : percentLogged}%`, height: '100%', backgroundColor: `${theme.palette.primary.main}`, borderRadius: 5 }} />
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Typography textAlign="right" fontSize="12px">{convertSecondsToTimeString(logged)}</Typography>
        </Grid>
      </Grid>

    </Box >
  );
};
function EditCases() {
  setTitle('CRM | Cases Edit');
  const { user } = useAuth();
  const { caseID } = useParams();
  const navigate = useNavigate();
  const checkPermissions = useHasPermissions();
  const roleLabels = {
    softwareDeveloper: 'Software Developer',
    qualityAssurance: 'Quality Assurance',
    graphicalDesigner: 'Graphical Designer',
    softwareArchitecture: 'Software Architect',
    operationalEngineer: 'Operational Engineer',
    consultant: 'Consultant',
    documentation: 'Documentation'
  };

  const classes = useStyles();
  const [caseData, setCaseData] = useState<CaseData>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [labelsData, setLabelsData] = useState<string[]>([]);
  const [dueDate, setDueDate] = useState<string>('');
  const [startDate, setStartDate] = useState<string>('');
  const [statusOptions, setStatusOptions] = useState<any>([]);
  const theme = useTheme();
  const [caseType, setCaseType] = useState<any>({});
  const [isLoad, setIsLoad] = useState<boolean>(false);
  const toggleIsLoad = () => setIsLoad(!isLoad);
  const [allLogs, setAllLogs] = useState<LogEntry[]>([]);
  const [description, setDescription] = useState<string>('');
  const [tabValue, setTabValue] = useState<number>(1);
  const [languageType, setLanguageType] = useState<string>('en');
  const [timeEstimate, setTimeEstimate] = useState('');
  const [loggedTime, setLoggedTime] = useState([]);
  const [totalTime, setTotalTime] = useState(0);
  const [totalLoggedTime, setTotalLoggedTime] = useState<any>('0h');
  const [remainingTime, setRemainingTime] = useState<any>('0h');
  const [isImagePopupOpen, setIsImagePopupOpen] = useState<boolean>(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState<string>('');
  const [selectedDocumentUrl, setSelectedDocumentUrl] = useState<string>('');
  const [isDocumentViewerOpen, setIsDocumentViewerOpen] =
    useState<boolean>(false);
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [isDeclineModalOpen, setIsDeclineModalOpen] = useState(false);
  // const [prioritiesAutoComplete, setPrioritiesAutoComplete] = useState<any>([]);
  // const [isPriorityEditMode, setIsPriorityEditMode] = useState<boolean>(false);
  // const [priority, setPriority] = useState<any>(null);
  const [caseObjectId, setCaseObjectId] = useState<string>('');
  const [isApproveProductionModalOpen, setIsApproveProductionModalOpen] =
    useState(false);
  const [isRejectProductionModalOpen, setIsRejectProductionModalOpen] =
    useState(false);

  const whiteLabel: any = JSON.parse(localStorage.getItem('white_label'));
  const getLoggedTimeByCategory = (loggedTimeArray = []): any => loggedTimeArray?.reduce((acc, logEntry) => {
    const category = logEntry?.billableAccount?.category;
    if (!category) return acc;

    acc[category] = (acc[category] || 0) + (logEntry.loggedHoursInSeconds || 0);
    return acc;
  }, {});
  const loggedTimeByCategory = getLoggedTimeByCategory(caseData?.loggedTime);
  const getStatusAutoComplete = async () => {
    try {
      const res = await casesApi?.getStatuses();
      setStatusOptions(res.data);
    } catch (error) {
      if (error.message) {
        toast.error(error.message);
      } else {
        toast.error('An error occured while fetching users');
      }
    }
  };
  const totalEstimatedSeconds = Object.values(caseData?.timeEstimateBreakDown || {}).reduce((sum: any, val: any) => sum + val, 0);
  const totalLoggedTimeSeconds = Object.values(loggedTimeByCategory || {}).reduce((sum: any, val: any) => sum + val, 0);
  const handleOpenApproveModal = () => {
    setIsApproveModalOpen(true);
  };

  const handleOpenDeclineModal = () => {
    setIsDeclineModalOpen(true);
  };

  const handleCloseApproveModal = () => {
    setIsApproveModalOpen(false);
  };

  const handleCloseDeclineModal = () => {
    setIsDeclineModalOpen(false);
  };

  const handleOpenApproveProductionModal = () => {
    setIsApproveProductionModalOpen(true);
  };

  const handleCloseApproveProductionModal = () => {
    setIsApproveProductionModalOpen(false);
  };

  const handleOpenRejectProductionModal = () => {
    setIsRejectProductionModalOpen(true);
  };

  const handleCloseRejectProductionModal = () => {
    setIsRejectProductionModalOpen(false);
  };

  // const getPrioritiesAutoComplete = async () => {
  //   try {
  //     const response = await casesApi?.getPriorities();
  //     setPrioritiesAutoComplete(response?.data);
  //   } catch (error) {
  //     logger(error);
  //   }
  // };

  const getCaseById = async () => {
    setIsLoading(true);
    try {
      const response = await casesApi?.getCaseById(caseID);
      if (response?.status === 204) {
        toast.error('No content found');
        navigate('/cases/all');
        return;
      }
      const res = response?.data;
      setCaseData(res);
      setCaseType(res?.caseType);
      setLabelsData(res?.labels);
      setAllLogs(res?.logs || []);
      setLoggedTime(res?.loggedTime || []);
      setDescription(res?.description || '');
      setDueDate(res?.dueDate);
      setStartDate(res?.startDate);
      // setPriority(res?.priority);
      const timeString = convertSecondsToTimeString(res?.timeEstimate);
      setTimeEstimate(timeString);
      setTotalTime(res?.timeEstimate);
      setCaseObjectId(res?.id);
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
        setCaseData(null);
        setLabelsData([]);
        setAllLogs([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleApprove = async () => {
    // Handle the approval logic here
    try {
      await casesApi.approveCase(caseObjectId);
      handleCloseApproveModal();
      await getCaseById();
      toast.success('Case Approved!');
    } catch (error) {
      logger(error);
      handleCloseApproveModal();
      toast.error('Failed to approve the case');
    }
  };

  const handleDecline = async (reason: string) => {
    // Handle the decline logic here, including using the reason
    try {
      const payload = {
        caseId: caseObjectId,
        description: reason,
        isExternal: true,
        attachmentPath: [],
      };
      await casesApi.createComment(payload);
      await casesApi.declineCase(caseObjectId);
      handleCloseDeclineModal();
      await getCaseById();
      toast.success('Case Declined!');
    } catch (error) {
      logger(error);
      handleCloseDeclineModal();
      toast.error('Failed to decline the case');
    }
  };

  const handleApproveProduction = async () => {
    try {
      const approvedStatus = statusOptions.find(
        (status) => status.name === 'Approved for Production'
      );
      const payload = {
        status: {
          id: approvedStatus.id,
          name: approvedStatus.name,
        },
      };
      const response = await casesApi.updateCase(caseData?.caseKey, payload);
      if (response?.status === 200) {
        toast.success('Case Approved for Production');
        handleCloseApproveProductionModal();
        getCaseById();
      }
      const commentPayload = {
        caseId: caseData?.id,
        description: 'This case has been approved for production',
        isExternal: true,
        attachmentPath: [],
      };
      try {
        await casesApi?.createComment(commentPayload);
        toggleIsLoad();
      } catch (error) {
        toast.error('Failed to create comment');
      }
    } catch (error) {
      handleCloseApproveProductionModal();
      toast.error('Failed to approve case for production');
    }
  };

  const handleRejectProduction = async (reason: string) => {
    try {
      const rejectedStatus = statusOptions.find(
        (status) => status.name === 'Rejected for Production'
      );
      const payload = {
        status: {
          id: rejectedStatus.id,
          name: rejectedStatus.name,
        },
      };
      const response = await casesApi.updateCase(caseData?.caseKey, payload);
      if (response?.status === 200) {
        toast.success('Case Rejected for Production');
        handleCloseRejectProductionModal();
        getCaseById();
      }
      const commentPayload = {
        caseId: caseData?.id,
        description: reason,
        isExternal: true,
        attachmentPath: [],
      };
      try {
        await casesApi?.createComment(commentPayload);
        toggleIsLoad();
      } catch (error) {
        toast.error('Failed to create comment');
      }
    } catch (error) {
      handleCloseRejectProductionModal();
      toast.error('Failed to reject case for production');
    }
  };

  const handleDocumentClick = (documentUrl) => {
    setSelectedDocumentUrl(documentUrl);
    setIsDocumentViewerOpen(true);
  };

  const handleCloseDocumentViewer = () => {
    setIsDocumentViewerOpen(false);
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImageUrl(imageUrl);
    setIsImagePopupOpen(true);
  };

  const handleCloseImagePopup = () => {
    setIsImagePopupOpen(false);
  };

  useEffect(() => {
    getStatusAutoComplete();
  }, []);

  useEffect(() => {
    // Sum all logged hours in seconds
    const totalLoggedSeconds = loggedTime.reduce(
      (acc, item) => acc + item?.loggedHoursInSeconds,
      0
    );

    setTotalLoggedTime(convertSecondsToTimeString(totalLoggedSeconds));

    setRemainingTime(
      convertSecondsToTimeString(totalTime - totalLoggedSeconds)
    );
  }, [totalTime]);

  const handleTabValue = (e: any, newValue: number) => {
    setTabValue(newValue);
  };

  const priorityColors = {
    highest: '#FF0000', // Red
    blocker: '#0d0d0d', // Orange Red
    high: '#F16063', // High (as specified)
    medium: '#FFA500', // Orange
    minor: '#FFD700', // Gold
    low: '#9ACD32', // Yellow Green
    lowest: '#0d0d0d', // Black
    backLog: '#808080', // Gray
  };
  const getColor = (priorityName: any) =>
    priorityColors[priorityName.toLowerCase()] || '#000000';

  const BreadCrumbsData = {
    title: '',
    links: [
      {
        name: 'cases',
        to: '/cases/all',
      },
      {
        name: `${caseData?.caseKey}`,
        to: 'copy',
        color: `${caseData?.issueType?.name === 'Bug' ? 'red' : '#4baee8'}`,
      },
      {
        name: `${caseData?.caseType?.name}`,
        to: `/cases/${caseID}`,
      },
    ],
  };

  // const updateIndividual = async (columnName: any, values: any) => {
  //   try {
  //     const payload = {
  //       [columnName]: values,
  //     };
  //     const caseKey = caseData?.caseKey;
  //     const response = await casesApi?.updateCase(caseKey, payload);
  //     if (response?.status === 200) {
  //       toast.success('Case Successfully Updated');
  //       getCaseById();
  //     }
  //   } catch (error) {
  //     if (error?.response?.status !== 401) {
  //       toast.error(error?.response?.data?.message);
  //     }
  //   }
  // };

  const showTranslation = async (
    textData: string,
    lang?: string,
    field?: string,
    id?: string
  ) => {
    const payload = {
      text: textData,
      target_lang: lang,
    };

    try {
      const res = await translationApi?.translateText(payload);
      const detectedLanguage =
        res?.data?.data?.translations[0].detectedSourceLanguage;
      const translatedText = res?.data?.data?.translations[0].translatedText;
      const updatedComments = caseData.comment.map((comment) => {
        if (comment.id === id) {
          return { ...comment, description: translatedText };
        }
        return comment;
      });
      const updatedLogs = caseData.logs.map((log) => {
        if (log.id === id) {
          return { ...log, change: translatedText };
        }
        return log;
      });
      // Define a conditional object to specify how to update the state based on the field
      const fieldActions = {
        caseSummary: () => {
          setCaseData({
            ...caseData,
            summary: translatedText,
          });
        },
        caseCommentData: () => {
          setCaseData({
            ...caseData,
            comment: updatedComments,
          });
        },
        caseLogData: () => {
          setCaseData({
            ...caseData,
            logs: updatedLogs,
          });
        },
        caseDescription: () => {
          setDescription(translatedText);
        },
        // Add more fields and actions as needed
      };

      // Call the appropriate action based on the field
      if (field && fieldActions[field]) {
        fieldActions[field]();
      }

      setLanguageType(detectedLanguage);
    } catch (error) {
      if (error?.response?.status !== 401) {
        setCaseData(null);
        toast.error(error?.response?.data?.message);
      }
    }
  };

  useEffect(() => {
    getCaseById();
  }, [isLoad]);

  // useEffect(() => {
  //   getPrioritiesAutoComplete();
  // }, []);

  const formatPlanningStatus = (status?: string): string => {
    if (!status) {
      return 'N/A';
    }
    return status
      .split('_')
      .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
      .join(' ');
  };
  const getPlanningStatusColor = (
    status?: string,
  ):
    string => {
    if (!status) {
      return 'default';
    }

    switch (status) {
      case 'PLANNED':
      case 'PLANNED_EXECUTED_AS_EXPECTED':
        return '#4caf50';
      case 'PLANNED_ADJUSTED_DURING_EXECUTION':
        return '#4caf50';
      case 'SCOPE_REDUCED':
      case 'SCOPE_EXPANDED':
        return '#e25807';
      case 'CANCELLED_BY_CLIENT_STAKEHOLDER':
      case 'CANCELLED_NO_LONGER_NEEDED':
        return '#F16063';
      case 'DEFERRED_TO_NEXT_SPRINT':
      case 'DEFERRED_BLOCKED_BY_DEPENDENCY':
        return '#e25807';
      case 'COMPLETED_AHEAD_OF_SCHEDULE':
        return '#4caf50';
      case 'COMPLETED_LATE_BUT_ACCEPTED':
        return '#e25807';
      case 'UNPLANNED':
      case 'NOT_STARTED_OUT_OF_SCOPE':
        return '#ff1e1e';
      default:
        return 'primary';
    }
  };

  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
          }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',

          }}
          className={classes.box} >
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            padding="10px 20px"
            sx={{
              backgroundColor: 'white', borderRadius: '10px', mx: '30px', marginTop: '30px', marginBottom: '0px',
            }} >
            <Typography fontSize="13px" fontWeight="500" maxWidth="70%">
              {caseData?.caseKey} - {caseData?.summary}
            </Typography>
            <Box>
              {caseData?.status?.name === ('Not Approved' as any) &&
                caseData?.caseKey.startsWith('AFR') &&
                whiteLabel?.isApprovalRequired && (
                  <>
                    {checkPermissions([CLIENT_CASES_UPDATE]) && caseData?.status?.name !== 'Declined' && (
                      <CustomButton
                        value={caseData?.isApproved ? 'Approved' : 'Approve'}
                        customClass={classes.approveCaseButton}
                        color="secondary"
                        onClick={handleOpenApproveModal}
                        disabled={caseData?.isApproved}
                      />
                    )}
                    {checkPermissions([CLIENT_CASES_UPDATE]) && !caseData?.isApproved && (
                      <CustomButton
                        value={
                          caseData?.status?.name === 'Declined'
                            ? 'Declined'
                            : 'Decline'
                        }
                        customClass={`${classes.declineCaseButton} ${classes.declineButtonRed}`}
                        onClick={handleOpenDeclineModal}
                        disabled={caseData?.status?.name === 'Declined'}
                      />
                    )}
                  </>
                )}

            </Box>
            {/* Use the ApproveDialog Component */}
            <ApproveDialog
              open={isApproveModalOpen}
              onClose={handleCloseApproveModal}
              onApprove={handleApprove}
            />

            {/* Use the DeclineDialog Component */}
            <DeclineDialog
              open={isDeclineModalOpen}
              onClose={handleCloseDeclineModal}
              onDecline={handleDecline}
            />
          </Box>
          <Box sx={{
            px: "30px",
            pb: '30px',
            pt: '10px'

          }}>
            <form>
              <Grid
                container
                gap='10px'
                sx={{ flexWrap: 'nowrap' }}>
                {/** Left Side Bar */}
                <Grid
                  container
                  item
                  xs={8}
                  sx={{
                    flexDirection: 'column',
                    gap: '10px',
                    minWidth: 0,
                  }}>
                  <Box className="boxSub">
                    <Grid container>
                      <Grid item xs={12}>
                        <Grid
                          container
                          justifyContent="space-between"
                          alignItems="center"
                          mb={1}>
                          <Grid item md={7}>
                            <SimpleBreadCrumb
                              data={BreadCrumbsData}
                              style={{ margin: 0 }}
                              onLinkClick={(href) => {
                                if (href === 'copy') {
                                  const caseText = `Case Title: ${caseData?.caseKey} - ${caseData?.summary}\nCase Link: https://portal.it22.nl/cases/${caseData?.caseKey}`;
                                  navigator.clipboard.writeText(caseText)
                                    .then(() => toast.success('Copied!'))
                                    .catch((err) => console.error('Failed to copy text: ', err));
                                }
                              }}
                            />
                          </Grid>
                          {checkPermissions([CLIENT_CASES_UPDATE]) &&
                            (caseData?.status?.name === 'Ready for Acceptance' ||
                              caseData?.status?.name === 'Rejected for Production') && (
                              <Grid item md={5}>
                                <Box display="flex" gap={2}>
                                  <CustomButton
                                    value="Approve for Production"
                                    // customClass={classes.editButton}
                                    rest={{
                                      style: {
                                        textWrap: 'nowrap',
                                        width: '100%',
                                      },
                                    }}
                                    color="primary"
                                    onClick={handleOpenApproveProductionModal}
                                  />
                                  <CustomButton
                                    value="Reject for Production"
                                    // customClass={classes.editButton}
                                    rest={{
                                      style: {
                                        textWrap: 'nowrap',
                                        width: '100%',
                                      },
                                    }}
                                    color="secondary"
                                    onClick={handleOpenRejectProductionModal}
                                    disabled={caseData?.status?.name === 'Rejected for Production'}
                                  />
                                </Box>
                              </Grid>
                            )}
                          {checkPermissions([CLIENT_CASES_UPDATE]) &&
                            caseData?.status?.name ===
                            'Approved for Production' && (
                              <Grid item md={5}>
                                <Box
                                  display="flex"
                                  justifyContent="flex-end"
                                  component="div">
                                  <Box
                                    component="div"
                                    sx={{
                                      backgroundColor: 'lightgray',
                                      color: 'white',
                                      padding: '5px 10px',
                                      borderRadius: '5px',
                                    }}>
                                    Approved for Production
                                  </Box>
                                </Box>
                              </Grid>
                            )}
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography className='caseTitleDescription'>
                          Title
                        </Typography>
                        <Box
                          sx={{
                            fontSize: '15px',
                            fontWeight: '700',
                            margin: 0,
                            padding: 0,
                          }}
                          id="title">
                          {caseData?.summary}
                        </Box>
                      </Grid>
                      <Grid item xs={12} sx={{ marginTop: "10px" }}>
                        <Typography className='caseTitleDescription'>
                          Description
                        </Typography>
                        <div data-color-mode="light" className="editorMarkup">
                          <Box
                            style={{
                              cursor: 'pointer',
                              marginTop: 8,
                              marginBottom: 8,
                              color: '#425466',
                              fontSize: '12px',
                              maxHeight: '300px',
                              overflowY: 'auto',
                              // padding: '8px',
                              // border: '1px solid #e0e0e0',
                              borderRadius: '4px',
                              scrollbarWidth: 'thin',
                              scrollbarColor: '#c1c1c1 #f1f1f1',
                            }}
                            sx={{
                              '&::-webkit-scrollbar': {
                                width: '6px',
                              },
                              '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                                borderRadius: '3px',
                              },
                              '&::-webkit-scrollbar-thumb': {
                                background: '#c1c1c1',
                                borderRadius: '3px',
                              },
                              '&::-webkit-scrollbar-thumb:hover': {
                                background: '#a8a8a8',
                              },
                            }}
                            id="description">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: description?.replace(/<img/g, '<img style="max-width: 100%; height: auto; object-fit: contain;"'),
                              }}
                            />
                          </Box>

                          <div>
                            {caseData?.caseType?.name === 'Application Bug' && (
                              <Box
                                style={{ cursor: 'pointer' }}
                                display="flex"
                                flexDirection="column"
                                gap="10px">
                                <label
                                  style={{ cursor: 'pointer' }}
                                  htmlFor="label">
                                  {caseData?.bugQuestions?.length >= 1
                                    ? caseData?.bugQuestions[0]?.questionKey
                                    : 'N/A'}
                                </label>
                                <Typography sx={{
                                  fontSize: '12px',
                                  margin: '0 !important',
                                  color: '#425466'
                                }}>{caseData?.bugQuestions?.[0]?.description ?? ''}</Typography>
                                <label
                                  style={{ cursor: 'pointer' }}
                                  htmlFor="label">
                                  {caseData?.bugQuestions?.length >= 2
                                    ? caseData?.bugQuestions[1]?.questionKey
                                    : 'N/A'}
                                </label>
                                <Typography sx={{
                                  fontSize: '12px',
                                  margin: '0 !important',
                                  color: '#425466'
                                }}>{caseData?.bugQuestions?.[1]?.description ?? ''}</Typography>
                              </Box>
                            )}
                          </div>

                          {caseData?.attachmentId?.length > 0 && (
                            <div className="attachmentsDiv">
                              <Typography
                                gutterBottom
                                variant="h4"
                                component="div"
                                sx={{
                                  marginBottom: '16px',
                                  // fontWeight: 'bolder',
                                  fontSize: '15px !important',
                                  color: '#888888'
                                }}>
                                Attachments
                              </Typography>

                              {caseData?.attachmentId?.length > 0 && (
                                <div className="editCommentFileParent">
                                  {caseData?.attachmentId?.map((item) => {
                                    // removed this because it was causing the image to not load 
                                    // const splittedUrl = item?.split('?');
                                    // splittedUrl[1] =
                                    //   'sp=racwdl&st=2024-02-27T13:21:58Z&se=2030-07-29T21:21:58Z&spr=https&sv=2022-11-02&sr=c&sig=YXOHT7%2Bx8VW3RDdgzehtPZLWJ6zHJz%2Bp3QtnduafL4o%3D';
                                    // item = splittedUrl?.join('?');
                                    const getFileType = (items) => {
                                      if (items.includes('.pdf')) {
                                        return 'PDF';
                                      }
                                      if (items.includes('.doc')) {
                                        return 'DOC';
                                      }
                                      if (items.includes('.docx')) {
                                        return 'DOCX';
                                      }
                                      if (items.includes('.txt')) {
                                        return 'TXT';
                                      }
                                      if (items.includes('.xls')) {
                                        return 'XLS';
                                      }
                                      if (items.includes('.xlsx')) {
                                        return 'XLSX';
                                      }
                                      if (items.includes('.csv')) {
                                        return 'CSV';
                                      }
                                      if (items.includes('.tsv')) {
                                        return 'TSV';
                                      }
                                      return null;
                                    };

                                    const fileType = getFileType(item);
                                    if (
                                      item?.includes('.pdf') ||
                                      item?.includes('.doc') ||
                                      item?.includes('.docx') ||
                                      item?.includes('.xls') ||
                                      item?.includes('.xlsx') ||
                                      item?.includes('.csv') ||
                                      item?.includes('.tsv') ||
                                      item?.includes('.txt')
                                    ) {
                                      return (
                                        <>

                                          <a
                                            role="presentation"
                                            onClick={() =>
                                              handleDocumentClick(item)
                                            }>
                                            <span style={{ fontSize: '10px' }}>{fileType}</span>
                                            <InsertDriveFileIcon
                                              sx={{ fontSize: '32px', marginTop: '-20px' }}
                                            />
                                          </a>
                                        </>
                                      );
                                    }
                                    const imageFormats = [
                                      '.jpg',
                                      '.jpeg',
                                      '.png',
                                      '.gif',
                                      '.bmp',
                                      '.tiff',
                                      '.webp',
                                      '.svg',
                                      '.ico',
                                    ];
                                    if (
                                      imageFormats.some((extension) =>
                                        item?.includes(extension)
                                      )
                                    ) {
                                      return (
                                        <>
                                          <a>
                                            <img
                                              role="presentation"
                                              src={item}
                                              alt="img"
                                              onClick={() =>
                                                handleImageClick(item)
                                              }
                                            />
                                          </a>
                                        </>
                                      );
                                    }
                                    return null;
                                  })}
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                      </Grid>
                    </Grid>
                  </Box>
                  <Box className='boxSub' sx={{
                    padding: "0 20px !important",
                    minWidth: 0,
                    overflow: 'hidden',
                  }}>
                    <Grid item xs={12} sx={{ minWidth: 0, width: '100%' }}>
                      <Card
                        style={{
                          // padding: '5px 10px',
                          boxShadow: 'none',
                          // borderRadius: '16px',
                        }}
                        sx={{
                          overflow: 'visible',
                          minWidth: 0,
                        }}>
                        <Tabs
                          value={tabValue}
                          onChange={handleTabValue}
                          style={{
                            borderBottom: '1px solid #D9D9D9',
                            paddingBottom: '10px'
                          }}
                          TabIndicatorProps={{
                            style: {
                              backgroundColor: theme.palette.primary.main,
                            },
                          }}>
                          <Tab
                            value={1}
                            label="Comments"
                            style={{ textTransform: 'none' }}
                          />
                        </Tabs>
                        <div>
                          {tabValue === 1 && (
                            <TimelineSection
                              data={allLogs}
                              caseData={caseData}
                              toggleIsLoad={toggleIsLoad}
                              user={user}
                              languageType={languageType}
                              showTranslation={showTranslation}
                              handleDocumentClick={handleDocumentClick}
                              handleImageClick={handleImageClick}
                            />
                          )}
                        </div>
                      </Card>
                    </Grid>
                  </Box>
                </Grid>


                <Grid
                  item
                  xs={4}
                  sx={{
                    '& .MuiAccordion-root.Mui-expanded': {
                      marginBottom: '0px !important',
                    },
                    '& .MuiAccordion-root.Mui-expanded:not(:first-of-type)': {
                      marginTop: '10px !important',
                    },
                  }}
                >
                  <Accordion className="rightSide" sx={{
                    borderRadius: '10px !important',
                  }}
                    defaultExpanded
                  >
                    <AccordionSummary
                      sx={{
                        padding: '0 16px !important',
                      }}
                      expandIcon={<ExpandMoreIcon />}>

                      <Typography variant="h4" sx={{
                        fontSize: '1rem !important',
                        fontWeight: 600,
                      }}>
                        Details
                      </Typography>

                    </AccordionSummary>
                    <AccordionDetails>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',

                          padding: '0px !important'
                        }}>
                        <div className="rightAccordion">

                          <div
                            style={{
                              display: 'grid',
                              gridTemplateColumns: '1fr 1fr ',
                              rowGap: '5px',

                            }}
                            className={classes.detailsCard}
                          >
                            <Typography fontSize="12px" fontWeight="700">
                              Status
                            </Typography>

                            <Typography
                              fontSize="12px"
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                              }}>
                              {caseData?.status?.name}
                            </Typography>

                            <Typography fontSize="12px" fontWeight="700">
                              Case Type
                            </Typography>

                            <Typography
                              fontSize="12px"
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                              }}>
                              {caseType?.name || 'N/A'}
                            </Typography>
                            <Typography fontSize="12px" fontWeight="700">
                              Project Budget
                            </Typography>

                            <Typography
                              fontSize="12px"
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                              }}>
                              {caseData?.budget?.name || 'N/A'}
                            </Typography>

                            <Typography fontSize="12px" fontWeight="700">
                              Priority
                            </Typography>

                            {/* {isPriorityEditMode ? (
                              <FormControl fullWidth>
                                <Select
                                  id="priorities"
                                  value={
                                    Object.keys(priority).length !== 0 &&
                                    priority?.id
                                  }
                                  onBlur={() => setIsPriorityEditMode(false)}
                                  onClick={(e) => {
                                    if (
                                      // user?.permissions?.includes(
                                      //   'case-update'
                                      // ) &&
                                      e
                                    ) {
                                      const getTarget: any = e.target;
                                      const dataName =
                                        getTarget?.getAttribute('data-name');
                                      const dataValue =
                                        getTarget?.getAttribute('data-value');
                                      if (dataValue !== null) {
                                        setPriority({
                                          ...priority,
                                          id: dataValue,
                                          name: dataName,
                                        });
                                        updateIndividual('priority', {
                                          ...priority,
                                          id: dataValue,
                                          name: dataName,
                                        });
                                      }
                                    }
                                    setIsPriorityEditMode(false);
                                  }}
                                  sx={{
                                    height: '25px',
                                    fontSize: '12px',
                                  }}
                                  size="small">
                                  {prioritiesAutoComplete?.map((opt) => (
                                    <MenuItem
                                      key={opt?.id}
                                      value={opt?.id}
                                      data-name={opt?.name}
                                      sx={{ fontSize: '12px !important' }}>
                                      {opt?.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            ) : ( */}
                            <Typography
                              fontSize="12px"
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                              }}
                            // onClick={() => setIsPriorityEditMode(true)}
                            >
                              <span
                                style={{
                                  display: 'inline-block',
                                  width: '8px',
                                  height: '8px',
                                  borderRadius: '50%',
                                  backgroundColor: getColor(
                                    caseData?.priority?.name || ''
                                  ),
                                  marginRight: '8px',

                                }} />
                              {caseData?.priority?.name}
                            </Typography>

                            {caseData?.caseType?.name === 'Application Bug' && (
                              <Typography fontSize="12px" fontWeight="700">
                                Severity
                              </Typography>
                            )}

                            {caseData?.caseType?.name === 'Application Bug' && (
                              <Typography
                                fontSize="12px"
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-start',
                                }}>
                                {caseData?.severity?.name || 'N/A'}
                              </Typography>
                            )}

                            <Typography fontSize="12px" fontWeight="700">
                              Assignee
                            </Typography>

                            <Typography
                              fontSize="12px"
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                              }}>
                              {caseData?.assignee?.name?.length
                                ? caseData?.assignee?.name
                                : 'N/A'}
                            </Typography>

                            <Typography fontSize="12px" fontWeight="700">
                              Project
                            </Typography>

                            <Typography
                              fontSize="12px"
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                              }}>
                              {caseData?.project?.name?.length
                                ? caseData?.project?.name
                                : 'N/A'}
                            </Typography>

                            <Typography fontSize="12px" fontWeight="700">
                              Sprints
                            </Typography>

                            <Typography
                              fontSize="12px"
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                              }}>
                              {caseData?.sprint?.name?.length > 0
                                ? caseData?.sprint?.name
                                : 'N/A'}
                            </Typography>

                            <Typography fontSize="12px" fontWeight="700">
                              Fix Versions
                            </Typography>
                            <Typography
                              fontSize="12px"
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                              }}>
                              {caseData?.releaseVersion?.length > 0
                                ? caseData?.releaseVersion[0]?.name
                                : 'N/A'}
                            </Typography>

                            <Typography fontSize="12px" fontWeight="700">
                              Labels
                            </Typography>
                            <Box display="flex" flexDirection="row" gap="5px" flexWrap="wrap" marginBottom="2px">
                              {labelsData?.length > 0 ? (
                                labelsData?.map((item) => (
                                  <Box key={item}>
                                    <Tooltip title={item}>
                                      <Chip
                                        sx={{
                                          cursor: 'pointer',
                                          display: 'flex',
                                          alignItems: 'center',
                                          color: 'black',
                                          textShadow: '2px black',
                                          maxWidth: '100px',
                                          fontSize: '12px'
                                        }}
                                        label={item}
                                        size="small"
                                      />

                                    </Tooltip>
                                  </Box>
                                ))
                              ) : (
                                <Box fontSize="12px" fontWeight="400">N/A</Box>
                              )}
                            </Box>

                            <Typography fontSize="12px" fontWeight="700">
                              Expense
                            </Typography>

                            <Box
                              sx={{
                                display: 'inline-flex',
                              }}
                              maxWidth="150px">
                              <Typography
                                fontSize="12px"
                                // color={
                                //   caseData?.expense === 'Opex'
                                //     ? theme.palette.primary.main
                                //     : 'rgba(29, 122, 21, 1)'
                                // }
                                color={
                                  theme.palette.primary.main
                                }
                                fontWeight="700"
                                sx={{
                                  cursor: 'pointer',
                                  // backgroundColor:
                                  //   caseData?.expense === 'Opex'
                                  //     ? `${theme.palette.primary.main}11`
                                  //     : 'rgba(7, 83, 0, 0.1)',
                                  backgroundColor: `${theme.palette.primary.main}11`,
                                  padding: '4px 8px',
                                  borderRadius: '4px',
                                }}>
                                {caseData?.expense || 'N/A'}
                              </Typography>
                            </Box>

                            <Typography fontSize="12px" fontWeight="700">
                              Start Date
                            </Typography>

                            <Box
                              sx={{
                                display: 'inline-flex',
                              }}
                              maxWidth="150px">
                              <Typography
                                fontSize="12px"
                                fontWeight="700"
                                sx={{ cursor: 'pointer' }}>
                                <Typography fontSize="12px">
                                  {startDate?.length > 0
                                    ? moment(startDate)?.format('DD MMM, YYYY')
                                    : 'N/A'}
                                </Typography>
                              </Typography>
                            </Box>

                            <Typography fontSize="12px" fontWeight="700">
                              Due Date
                            </Typography>
                            <Box
                              sx={{
                                display: 'inline-flex',
                              }}
                              maxWidth="150px">
                              <Typography
                                fontSize="12px"
                                fontWeight="700"
                                sx={{ cursor: 'pointer' }}>
                                <Typography fontSize="12px">
                                  {dueDate?.length > 0
                                    ? moment(dueDate)?.format('DD MMM, YYYY')
                                    : 'N/A'}
                                </Typography>
                              </Typography>
                            </Box>

                            <Typography fontSize="12px" fontWeight="700">
                              Time Estimate
                            </Typography>

                            <Typography fontSize="12px">
                              {timeEstimate || '0h'}
                            </Typography>

                            <Typography fontSize="12px" fontWeight="700">
                              Logged Time
                            </Typography>

                            <Typography fontSize="12px">
                              {totalLoggedTime || '0h'}
                            </Typography>

                            <Typography fontSize="12px" fontWeight="700">
                              Remaining Time
                            </Typography>

                            <Typography fontSize="12px">
                              {remainingTime || '0h'}
                            </Typography>

                            {/* <Typography fontSize="12px" fontWeight="700">
                              Account
                            </Typography>

                            <Typography fontSize="12px">
                              {caseData?.billingAccountType?.name?.length > 0
                                ? caseData?.billingAccountType?.name
                                : 'N/A'}
                            </Typography> */}

                            <Typography fontSize="12px" fontWeight="700">
                              Case Owner / Reporter
                            </Typography>
                            <Typography fontSize="12px" fontWeight="700">
                              {caseData?.createdBy?.name?.length > 0
                                ? caseData?.createdBy?.name
                                : 'N/A'}
                            </Typography>
                          </div>
                        </div>

                        <div
                          className="createdAt"
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginTop: '10px',
                            fontSize: '12px',
                            fontStyle: 'italic',
                          }}>
                          <p
                            title={moment.utc(caseData?.createdAt).local().format(
                              'DD MMM, YYYY - HH:mm:ss'
                            )}>
                            Created:{' '}
                            <span>
                              {time.absoluteTime(caseData?.createdAt)}
                            </span>
                          </p>
                          <p
                            title={moment.utc(caseData?.updatedAt).local().format(
                              'DD MMM, YYYY - HH:mm:ss'
                            )}>
                            Updated:{' '}
                            <span>
                              {time.absoluteTime(caseData?.updatedAt)}
                            </span>
                          </p>
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                  {caseData?.timeEstimateBreakDown && Object.keys(caseData.timeEstimateBreakDown).length > 0 && (
                    <Accordion
                      className="rightSide"
                      sx={{
                        borderRadius: '10px !important',
                        marginTop: '10px',
                        '&::before': { display: 'none' },
                      }}
                      defaultExpanded
                    >
                      <AccordionSummary
                        sx={{
                          padding: '0 16px !important',
                        }}
                        expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="h4" sx={{
                          fontSize: '1rem !important',
                          fontWeight: 600,
                        }}>
                          Time Tracking{' '}
                          <span style={{ fontSize: '10px', fontWeight: '400', color: 'gray' }}>
                            (Logged/Estimated)
                          </span>
                        </Typography>
                      </AccordionSummary>

                      <AccordionDetails>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            padding: '0px !important'
                          }}>
                          <div className="rightAccordion">
                            <Grid container rowGap={1}>
                              {Object.keys(caseData.timeEstimateBreakDown).map((key) => (
                                <Fragment key={key}>
                                  <Grid item xs={6}>
                                    <Typography fontSize="12px" fontWeight="400" color="gray">
                                      {roleLabels[key]}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={6}>
                                    <Typography textAlign="right" fontSize="12px" fontWeight="400">
                                      {convertSecondsToTimeString(loggedTimeByCategory[key] || 0)}/
                                      {convertSecondsToTimeString(caseData.timeEstimateBreakDown[key])}
                                    </Typography>
                                  </Grid>
                                </Fragment>
                              ))}
                            </Grid>

                            <Divider sx={{ marginY: '8px' }} />

                            <Grid container>
                              <Grid item xs={6}>
                                <Typography fontSize="12px" fontWeight="400">
                                  Total:
                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography fontSize="12px" textAlign="right" fontWeight="400">
                                  {convertSecondsToTimeString(totalLoggedTimeSeconds)}/
                                  {convertSecondsToTimeString(totalEstimatedSeconds)}
                                </Typography>
                              </Grid>
                            </Grid>

                            <Divider sx={{ marginY: '8px' }} />

                            <TimeProgress
                              estimated={caseData.timeEstimate}
                              remaining={caseData.timeEstimate - Number(totalLoggedTimeSeconds)}
                              logged={Number(totalLoggedTimeSeconds)}
                            />
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  )}

                  <Accordion
                    className="rightSide"
                    sx={{ borderRadius: '10px !important', marginTop: '10px', '&::before': { display: 'none' }, }}
                    defaultExpanded
                  >
                    <AccordionSummary
                      sx={{
                        padding: '0 16px !important',
                      }}
                      expandIcon={<ExpandMoreIcon />}>
                      <Typography
                        variant="h4"
                        sx={{
                          fontSize: '1rem !important',
                          fontWeight: 600,
                        }}
                      >
                        Cases Attachments
                      </Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >


                        {/* Google Doc Links */}
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            rowGap: '15px',
                          }}
                        >
                          <Typography fontSize="12px" fontWeight="700" color="#7a7a9d">
                            Google Doc Links
                          </Typography>

                          {(caseData?.docUrls?.googleDocLinks?.length === 0 ||
                            !caseData?.docUrls?.googleDocLinks) ? (
                            <Typography fontSize="12px" fontWeight="400">
                              No Documents Available
                            </Typography>
                          ) : (
                            <Stack direction="row" spacing={1} flexWrap="wrap">
                              {caseData?.docUrls?.googleDocLinks?.map((item) => (
                                <Chip
                                  key={item?.url || item?.label}
                                  label={item?.label}
                                  component="a"
                                  href={item?.url}
                                  target="_blank"
                                  rel="noreferrer"
                                  clickable
                                  variant="outlined"
                                  sx={{
                                    fontSize: '12px',
                                    height: 24,
                                    borderRadius: '16px',
                                    color: theme.palette.primary.main,
                                    borderColor: `${theme.palette.primary.main}90`,
                                    '&:hover': {
                                      backgroundColor: `${theme.palette.primary.main}33`,
                                      textDecoration: 'none'
                                    },
                                  }}
                                />
                              ))}
                            </Stack>
                          )}
                        </div>

                        {/* Figma Links */}
                        <div
                          style={{
                            marginTop: '10px',
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            rowGap: '15px',
                          }}
                        >
                          <Typography fontSize="12px" fontWeight="700" color="#7a7a9d">
                            Figma Links
                          </Typography>

                          {(caseData?.docUrls?.figmaLinks?.length === 0 ||
                            !caseData?.docUrls?.figmaLinks) ? (
                            <Typography fontSize="12px" fontWeight="400">
                              No Documents Available
                            </Typography>
                          ) : (
                            <Stack direction="row" spacing={1} flexWrap="wrap">
                              {caseData?.docUrls?.figmaLinks?.map((item) => (
                                <Chip
                                  key={item?.url || item?.label}
                                  label={item?.label}
                                  component="a"
                                  href={item?.url}
                                  target="_blank"
                                  rel="noreferrer"
                                  clickable
                                  variant="outlined"
                                  sx={{
                                    fontSize: '12px',
                                    height: 24,
                                    borderRadius: '16px',
                                    color: theme.palette.primary.main,
                                    borderColor: `${theme.palette.primary.main}90`,
                                    '&:hover': {
                                      backgroundColor: `${theme.palette.primary.main}33`,
                                      textDecoration: 'none'
                                    },
                                  }}
                                />
                              ))}
                            </Stack>
                          )}
                        </div>

                      </div>
                    </AccordionDetails>
                  </Accordion>


                  {(caseData?.sprint && caseData?.releaseVersion?.length > 0) && (
                    <Accordion
                      className="rightSide"
                      sx={{ borderRadius: '10px !important', marginTop: '10px', '&::before': { display: 'none' }, }}
                      defaultExpanded
                    >
                      <AccordionSummary
                        sx={{
                          padding: '0 16px !important',
                        }}
                        expandIcon={<ExpandMoreIcon />}>
                        <Typography
                          variant="h5"
                          sx={{
                            fontSize: '1rem !important',
                            fontWeight: 600,
                          }}
                        >
                          Planning Details
                        </Typography>
                      </AccordionSummary>

                      <AccordionDetails>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                        >
                          <Grid container spacing={2} className={classes.detailsCard}>
                            <Grid item xs={5}>
                              <Typography fontSize="12px" fontWeight="600">
                                Planning Status
                              </Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Chip
                                label={formatPlanningStatus(
                                  caseData?.generalStatus?.planningStatus
                                )}
                                size="small"
                                variant="outlined"
                                sx={{
                                  fontSize: 12,
                                  height: 20,
                                  color: getPlanningStatusColor(
                                    caseData?.generalStatus?.planningStatus
                                  ),
                                }}
                              />
                            </Grid>

                            <Grid item xs={5}>
                              <Typography fontSize="12px" fontWeight="600">
                                Sprint
                              </Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography fontSize="12px" fontWeight="400">
                                {caseData?.sprint?.name || 'N/A'}
                              </Typography>
                            </Grid>

                            <Grid item xs={5}>
                              <Typography fontSize="12px" fontWeight="600">
                                Release Version
                              </Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography fontSize="12px" fontWeight="400">
                                {caseData?.releaseVersion?.[0]?.name || 'N/A'}
                              </Typography>
                            </Grid>

                            <Grid item xs={5}>
                              <Typography fontSize="12px" fontWeight="600">
                                Expected Start Date
                              </Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography fontSize="12px" fontWeight="400">
                                {caseData?.expectedStartDate
                                  ? formatDate(caseData.expectedStartDate)
                                  : 'N/A'}
                              </Typography>
                            </Grid>

                            <Grid item xs={5}>
                              <Typography fontSize="12px" fontWeight="600">
                                Expected End Date
                              </Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography fontSize="12px" fontWeight="400">
                                {caseData?.expectedEndDate
                                  ? formatDate(caseData.expectedEndDate)
                                  : 'N/A'}
                              </Typography>
                            </Grid>
                          </Grid>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  )}

                  <Accordion
                    className="linkCaseCard"
                    sx={{ borderRadius: '10px !important', marginTop: '10px', '&::before': { display: 'none' }, }}
                    defaultExpanded
                  >
                    <AccordionSummary
                      sx={{
                        padding: '0 16px !important',
                      }}
                      expandIcon={<ExpandMoreIcon />}>
                      <Typography
                        variant="h5"
                        sx={{ fontWeight: 'bold', fontSize: '1rem' }}
                        component="div"
                      >
                        Linked Cases
                      </Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                      <div className="orgInfo">
                        <Box
                          sx={{
                            flex: 1,
                            marginBottom: '0px',
                          }}
                        >
                          {(!caseData?.linkedCases || caseData?.linkedCases.length === 0) ? (
                            <Typography
                              variant="h5"
                              sx={{
                                fontSize: '12px',
                                fontWeight: 600,
                                textAlign: 'center',
                                marginBottom: '0px',
                                padding: '10px',
                              }}
                            >
                              Link Case(s) Not Available
                            </Typography>
                          ) : (
                            Object.entries(
                              caseData.linkedCases.reduce(
                                (acc: Record<string, typeof caseData.linkedCases>, linkedCase) => {
                                  const groupKey = linkedCase?.key || 'Unknown';
                                  if (!acc[groupKey]) acc[groupKey] = [];
                                  acc[groupKey].push(linkedCase);
                                  return acc;
                                },
                                {} as Record<string, typeof caseData.linkedCases>
                              )
                            ).map(([groupKey, cases]) => (
                              <Box
                                key={groupKey}
                                sx={{
                                  marginBottom: '10px',
                                }}
                              >
                                {/* Group title */}
                                <Typography
                                  variant="h5"
                                  sx={{
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    marginBottom: '6px',
                                  }}
                                >
                                  {groupKey}
                                </Typography>

                                {/* Each case under this key */}
                                {(cases as typeof caseData.linkedCases).map((linkedCase) => (
                                  <Link
                                    key={linkedCase?.id}
                                    href={`/cases/${linkedCase?.caseKey}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'flex-start',
                                      alignItems: 'center',
                                      flexWrap: 'wrap',
                                      marginRight: 10,
                                      marginTop: 4,
                                      width: '100%',
                                      fontSize: '12px',
                                      cursor: 'pointer',
                                      padding: '10px',
                                      backgroundColor: 'rgba(237, 237, 237, 0.2)',
                                      wordBreak: 'break-word',
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        mr: 1,
                                        fontSize: '12px',
                                        fontWeight: 500,
                                      }}
                                    >
                                      {linkedCase?.caseKey}
                                    </Typography>

                                    <Typography
                                      className="caseName"
                                      sx={{
                                        fontSize: '12px',
                                        fontWeight: 500,
                                        textAlign: 'left',
                                        color: '#000',
                                      }}
                                    >
                                      {linkedCase?.name}
                                    </Typography>
                                  </Link>
                                ))}
                              </Box>
                            ))
                          )}
                        </Box>
                      </div>
                    </AccordionDetails>
                  </Accordion>

                </Grid>
              </Grid>

              <Dialog open={isImagePopupOpen} onClose={handleCloseImagePopup} maxWidth="lg" fullWidth>
                <DialogContent sx={{ p: 2 }}>
                  <ImagePreviewer imageUrl={selectedImageUrl} onClose={handleCloseImagePopup} />
                </DialogContent>
              </Dialog>

              {isDocumentViewerOpen && (
                <DocumentViewer
                  documentUrl={selectedDocumentUrl}
                  isOpen={isDocumentViewerOpen}
                  onClose={handleCloseDocumentViewer}
                />
              )}
            </form>
          </Box>
        </Box>
      )}
      <ApproveProductionDialog
        open={isApproveProductionModalOpen}
        onClose={handleCloseApproveProductionModal}
        onApprove={handleApproveProduction}
      />
      <RejectProductionDialog
        open={isRejectProductionModalOpen}
        onClose={handleCloseRejectProductionModal}
        onReject={handleRejectProduction}
      />
    </>
  );
}

export default EditCases;
